<template>
  <VpProFeature title="History" feature="CONTACT_BULK_UPLOAD">
    <ProcessExcelHistory module="contact" feature="CONTACT_BULK_UPLOAD" />
  </VpProFeature>
</template>

<script>
import ProcessExcelHistory from "../../process-excel/history.vue";

export default {
  components: {
    ProcessExcelHistory,
  },
};
</script>
